module.exports = __webpack_public_path__ + "static/img/14.1424177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/14.png
// module id = skPn
// module chunks = 0